import React, { useState } from 'react';
import { DollarSign } from 'lucide-react';
import { adminFetch, AuthError } from './adminApi';
import { inputStyle, labelStyle, helpStyle } from '../quote/quoteStyles';

export const QuoteReplyPanel = ({ item, onSent, onAuthError }) => {
  const [amount, setAmount] = useState('');
  const [terms, setTerms] = useState('');
  const [validDays, setValidDays] = useState(14);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const send = async (e) => {
    e.preventDefault();
    setSaving(true); setMessage('');
    try {
      const res = await adminFetch(`/api/inbox/items/${item.kind}/${item.id}/quote`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: parseFloat(amount), terms, valid_days: Number(validDays) })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Unable to send quote');
      setMessage('Quote emailed with an Approve & Place Order link.'); setAmount(''); setTerms('');
      onSent(data.summary);
    } catch (err) {
      if (err instanceof AuthError) onAuthError(); else setMessage(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={send} data-testid="quote-reply-form" style={{ padding: '1rem', borderRadius: '10px', backgroundColor: 'rgba(44,90,160,0.05)', border: '1px solid var(--brand-primary)', marginBottom: '1.5rem', display: 'grid', gap: '0.6rem' }}>
      <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '0.4rem', color: 'var(--brand-primary)', fontSize: '0.95rem' }}><DollarSign size={16} /> Send a quote</h4>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.6rem' }}>
        <div>
          <label htmlFor="quote-amount" style={{ ...labelStyle, fontSize: '0.85rem' }}>Amount (USD)</label>
          <input id="quote-amount" data-testid="quote-reply-amount" type="number" min="1" step="0.01" required value={amount} onChange={(e) => setAmount(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label htmlFor="quote-valid" style={{ ...labelStyle, fontSize: '0.85rem' }}>Valid for (days)</label>
          <input id="quote-valid" data-testid="quote-reply-valid-days" type="number" min="1" max="90" required value={validDays} onChange={(e) => setValidDays(e.target.value)} style={inputStyle} />
        </div>
      </div>
      <div>
        <label htmlFor="quote-terms" style={{ ...labelStyle, fontSize: '0.85rem' }}>What's included / terms</label>
        <textarea id="quote-terms" data-testid="quote-reply-terms" required rows={3} value={terms} onChange={(e) => setTerms(e.target.value)} placeholder="e.g. Up to 3 attempts at one address, proof of service filed with the court. Court fees billed at cost." style={{ ...inputStyle, resize: 'vertical' }} />
      </div>
      <button type="submit" className="btn-primary" data-testid="quote-reply-send" disabled={saving} style={{ padding: '0.7rem' }}>{saving ? 'Sending...' : 'Email Quote to Client'}</button>
      {message && <p data-testid="quote-reply-message" style={{ margin: 0, fontSize: '0.85rem', color: message.startsWith('Quote emailed') ? '#2f855a' : '#c53030' }}>{message}</p>}
      <p style={{ ...helpStyle, margin: 0 }}>The email includes an "Approve & Place Order" button that pre-fills the order form.</p>
    </form>
  );
};
